export const REGISTER_OPTIONS = [
  'private client',
  'business client',
  'business worker',
  'asset owner',
] as const;

export type RegisterOption = (typeof REGISTER_OPTIONS)[number];

export const BUSINESS_WORKER_REGISTER_OPTION = 'business worker' satisfies RegisterOption;
